module.exports = __webpack_public_path__ + "media/site/images/coffeetime/coffeetime-coffee-74317e43b5506b80043518aff251ec3d.png";